import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

/**
 * One-time native setup: put the iOS keyboard in Native resize mode so the
 * WKWebView shrinks when the keyboard shows/hides and CSS `dvh` units reflect
 * the available height. This is what lets `ResponsiveModal`'s sticky footer
 * ride above the keyboard declaratively. No-op on web (the browser already
 * resizes the visual viewport). Call once at app startup.
 *
 * Native resize is the plugin's default; setting it explicitly pins the intent
 * so a plugin upgrade can't silently change it.
 */
export async function initNativeKeyboard(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
  } catch (error) {
    console.warn('Failed to set keyboard resize mode:', error);
  }
}
